import { Button } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { TachoTabs } from './TachographPopup';
import { ctxTachograph } from '@/contexts/TachographCtx';
import { FileDownload } from '@mui/icons-material';

export default function TachographGenerateButton({ activeTab }: { activeTab: TachoTabs }) {
  const { t } = useTranslation();
  const tachographCtx = useContext(ctxTachograph);

  const options = [t('tachograph.downloadButton.downloadGeneralFile'), t('tachograph.downloadButton.downloadHrFile')];

  function downloadUrl() {
    if (
      !tachographCtx ||
      !tachographCtx.selectedDates ||
      !tachographCtx.selectedDates.from ||
      !tachographCtx.selectedDates.to ||
      (tachographCtx.selectedRowIds.length == 0 && tachographCtx.selectedRowCardNumbers.length == 0)
    ) {
      return undefined;
    }

    const params = new URLSearchParams();

    if (activeTab === 'TargetTab') {
      tachographCtx.selectedRowIds.forEach((id) => params.append('id', id.toString()));
      params.append('isCroatianFileName', tachographCtx.isCroatian.toString());
      params.append('fromTimeMillis', tachographCtx.selectedDates.from.getTime().toString());
      params.append('toTimeMillis', tachographCtx.selectedDates.to.getTime().toString());

      if (tachographCtx.selectedRowIds.length > 1) {
        return `/api/v1.1/tachograph/downloadMultipleVehicleData?${params.toString()}`;
      }

      return `/api/v1.1/tachograph/downloadSingleVehicleData?${params.toString()}`;
    } else {
      tachographCtx.selectedRowCardNumbers.forEach((driverCardNumber) => {
        const onlyCardNumber = driverCardNumber.toString().split('_')[1];
        params.append('driverCardNumbers', onlyCardNumber);
      });
      params.append('isCroatianFileName', tachographCtx.isCroatian.toString());
      params.append('fromTimeMillis', tachographCtx.selectedDates.from.getTime().toString());

      if (tachographCtx.selectedRowCardNumbers.length > 1) {
        return `/api/v1.1/tachograph/downloadMultipleDriverData?${params.toString()}`;
      }

      return `/api/v1.1/tachograph/downloadSingleDriverData?${params.toString()}`;
    }
  }

  const url = downloadUrl();

  return (
    <>
      <Button
        href={url || '#'}
        download
        disabled={!url}
        variant="contained"
        color={activeTab === 'DriverTab' ? 'secondary' : 'primary'}
        className="tachograph-generate-button"
      >
        <FileDownload sx={{ marginRight: '10px' }} />
        {options[tachographCtx?.isCroatian ? 1 : 0]}
      </Button>
    </>
  );
}
